import React, { Fragment, useState } from 'react';
import {
  Tabs,
  Row,
  Col,
  Table,
  Button,
  Divider,
  Tooltip,
  Checkbox,
} from 'antd';
import {
  FileTextOutlined,
  FileSearchOutlined,
  HistoryOutlined,
  DownloadOutlined,
  FileProtectOutlined,
} from '@ant-design/icons';
import {
  CustomButton,
  CustomModal,
  CustomSelectableTable,
  CustomTable,
  CustomText,
  CustomTextArea,
  FormInput,
} from '../../../../components';
import {
  ISelectedItems,
  Item,
  RefundsRequest,
} from '../../types/refunds-response';
import { ShareResponse } from '../../../../share';
import ManageAllAsset from '../components/ByRoles/ManageAllAsset';
import ManageOneAsset from '../components/ByRoles/ManageOneAsset';

interface RefundsDetailViewProps {
  detailData?: RefundsRequest;
  setFooterLeft: (footer: React.ReactNode) => void;
  onVoucher?: (id: string) => void;
  onDocuments: (id: string) => void;
  refundStates?: ShareResponse[];
  handleSaveAddition?: (data: any) => void;
  gestorFromWarehouse?: boolean;
  selectedRowKeys?: React.Key[];
  setSelectedRowKeys?: React.Dispatch<React.SetStateAction<React.Key[]>>;
  formikGestor: any;
  modalOneAsset?: any;
  setModalOneAsset?: any;
  modalAllAsset?: any;
  setModalAllAsset?: any;
  setIsGestorAny?: any;
  selectedItemsFull?: ISelectedItems[];
  setSelectedItemsFull?: React.Dispatch<React.SetStateAction<ISelectedItems[]>>;
  formikItem?: any;
  dataItems: Item[];
  isLoadingItems: boolean;
}

const RefundsDetailView: React.FC<RefundsDetailViewProps> = ({
  detailData,
  setFooterLeft,
  onDocuments,
  onVoucher,
  refundStates,
  handleSaveAddition,
  gestorFromWarehouse,
  selectedRowKeys,
  setSelectedRowKeys,
  formikGestor,
  modalOneAsset,
  setModalOneAsset,
  modalAllAsset,
  setModalAllAsset,
  setIsGestorAny,
  selectedItemsFull,
  setSelectedItemsFull,
  formikItem,
  dataItems,
  isLoadingItems,
}) => {
  const [filteredData, setFilteredData] = useState<any>(
    dataItems ? dataItems.length > 0 : []
  );

  const [searchText, setSearchText] = useState('');
  const [itemSelected, setItemSelected] = useState<any>();
  const [columnAsset, setColumnAsset] = useState<any>([]);
  const [columnGood, setColumnGood] = useState<any>([]);
  const [managedItems, setManagedItems] = useState<any[]>([]);

  const handleSelectionChange = (selectedRowKeys: any) => {
    setSelectedRowKeys?.(selectedRowKeys);
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event?.target?.value || '';
    setSearchText(value);

    const baseData: any =
      Array.isArray(managedItems) && managedItems.length > 0
        ? managedItems
        : Array.isArray(selectedItemsFull) && selectedItemsFull.length > 0
          ? selectedItemsFull
          : Array.isArray(dataItems)
            ? dataItems
            : [];

    if (!value) {
      setFilteredData(baseData); // ← Mostrar todos si no hay búsqueda
    } else {
      const filtered = baseData.filter(
        (item: any) =>
          String(item?.id).toLowerCase().includes(value.toLowerCase()) ||
          item?.plate_code?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };
  const handleCancel = () => {
    setModalOneAsset(false);
    //setIsGestorAny(false);
  };
  React.useEffect(() => {
    if (modalOneAsset) {
      formikItem.resetForm();
    }
  }, [modalOneAsset]);

  React.useEffect(() => {
    if (modalAllAsset) {
      formikItem.resetForm();
    }
  }, [modalAllAsset]);

  React.useEffect(() => {
    if (!dataItems || dataItems[0] === null) {
      setFilteredData([]);
    } else {
      setFilteredData(dataItems);
    }
  }, [dataItems]);

  // FOOTER
  React.useEffect(() => {
    setFooterLeft(
      <Fragment>
        <CustomButton
          disabled={Number(detailData?.status_id) !== 7}
          label={'Generar comprobante'}
          onClick={() => onVoucher?.(String(detailData?.id_petition))}
          icon={<FileProtectOutlined />}
          size="middle"
          noBorder
          buttonType={'secondary'}
        />
        <CustomButton
          disabled={
            !detailData?.documents || detailData?.documents.length === 0
          }
          label={'Descargar documentos'}
          onClick={() => onDocuments(String(detailData?.id))}
          icon={<DownloadOutlined />}
          size="middle"
          buttonType={'secondary'}
        />
      </Fragment>
    );
  }, [setFooterLeft, detailData?.id]);

  const onSaveManageAllAsset = () => {
    let items = selectedItemsFull ? [...selectedItemsFull] : [];

    selectedRowKeys?.forEach((id: any) => {
      const existingIndex = items.findIndex((item) => item.id === id);

      if (existingIndex !== -1) {
        items[existingIndex] = {
          ...items[existingIndex],
          status_id: formikItem.values.status_id,
          observations: formikItem.values.observationsItem,
        };
      } else {
        items.push({
          id,
          status_id: formikItem.values.status_id,
          observations: formikItem.values.observationsItem,
        });
      }
    });
    setSelectedItemsFull?.(items);

    const statusLabel: any = {
      '15': 'Recibido',
      '10': 'Rechazado',
    };

    const sourceData = Array.isArray(dataItems)
      ? dataItems
      : [];

    // Crear un Map con los items ya gestionados
    const updatedMap = new Map(managedItems.map((item) => [item.id, item]));

    sourceData?.forEach((item: any) => {
      if (selectedRowKeys?.includes(item.id)) {
        const updatedItem = {
          ...item,
          observations: formikItem.values.observationsItem,
          status: {
            id: Number(formikItem.values.status_id),
            status: statusLabel[formikItem.values.status_id] || 'Desconocido',
          },
        };
        updatedMap.set(item.id, updatedItem); // ← actualiza o inserta
      }
    });

    const newManagedItems = Array.from(updatedMap.values());

    // Genera la vista actualizada con base completa
    const currentView = (dataItems || []).map((item) => {
      const managed = updatedMap.get(item.id);
      return managed ? { ...item, ...managed } : item;
    });

    setManagedItems(newManagedItems);
    setFilteredData(currentView);
    setModalAllAsset(false);
    setIsGestorAny(true);
  };

  const capitalizeFirstLetter = (text?: string): string => {
    if (!text) return '';
    const lower = text.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };
  const onSaveManageOneAsset = () => {
    let items = selectedItemsFull ? [...selectedItemsFull] : [];

    if (items.length > 0) {
      const existingItem = items.find((item) => item.id === itemSelected.id);

      if (existingItem) {
        existingItem.status_id = formikItem.values.status_id;
        existingItem.observations = formikItem.values.observationsItem;
      } else {
        items.push({
          id: itemSelected.id,
          status_id: formikItem.values.status_id,
          observations: formikItem.values.observationsItem,
        });
      }
    } else {
      items.push({
        id: itemSelected.id,
        status_id: formikItem.values.status_id,
        observations: formikItem.values.observationsItem,
      });
    }
    setSelectedItemsFull?.(items);

    const statusLabel: any = {
      '15': 'Recibido',
      '10': 'Rechazado',
    };

    // Obtén la versión original completa del ítem
    const originalItem =
      managedItems.find((i) => i.id === itemSelected.id) ||
      dataItems?.find((i) => i.id === itemSelected.id) ||
      itemSelected; // respaldo por si acaso

    // Construye el ítem actualizado conservando todo
    const updatedItem = {
      ...originalItem, // ← mantiene toda la info previa
      observations: formikItem.values.observationsItem,
      status: {
        id: Number(formikItem.values.status_id),
        status: statusLabel[formikItem.values.status_id] || 'Desconocido',
      },
    };

    // Actualiza el map y la lista gestionada
    const updatedMap = new Map(managedItems.map((item) => [item.id, item]));
    updatedMap.set(updatedItem.id, updatedItem);

    const newManagedItems = Array.from(updatedMap.values());

    // Genera la vista actual
    const original = dataItems || [];
    const currentView = original.map((item) => {
      const managed = updatedMap.get(item.id);
      return managed ? { ...item, ...managed } : item;
    });

    setManagedItems(newManagedItems);
    setFilteredData(currentView);
    setIsGestorAny(true);
    setModalOneAsset(false);
  };

  React.useEffect(() => {
    setColumnAsset([
      {
        title: 'Item',
        dataIndex: 'id',
        key: 'id',
        render: (item: any) => (item && item ? item : 'Sin registro'),
      },
      {
        title: 'Código/placa',
        dataIndex: 'plate_code',
        key: 'plate_code',
        render: (item: any) => (item && item ? item : 'Sin registro'),
      },
      {
        title: 'Descripción',
        dataIndex: 'asset',
        key: 'asset',
        render: (item: any) => (item && item ? item : 'Sin registro'),
      },
      {
        title: 'Clase de activo',
        dataIndex: 'class',
        key: 'class',
        render: (_: any, record: any) => {
          return record.class_code && record.class
            ? `${record.class_code} - ${record.class}`
            : 'Sin registro';
        },
      },
      {
        title: 'Artículo',
        dataIndex: 'item',
        key: 'item',
        render: (_: any, record: any) => {
          return record.item && record.plate_code
            ? `${record.plate_code} - ${record.item}`
            : 'Sin registro';
        },
      },
      {
        title: 'Adiciones',
        dataIndex: 'assets',
        key: 'assets',
        render: (item: any) => (item && item.length ? item.length : '0'),
      },
      {
        title: 'Estado por elemento',
        dataIndex: 'status',
        key: 'status',
        render: (status: any) =>
          status ? status : 'Sin registro',
      },
      {
        title: 'Observaciones',
        dataIndex: 'observations',
        key: 'observations',
        width: 300,
        render: (text: any, record: any) => {
          return (
            <Tooltip title={text ? text : 'Sin registro'}>
              <div
                style={{
                  maxWidth: 250,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  margin: '0 auto',
                }}
              >
                {text ? text : 'Sin registro'}
              </div>
            </Tooltip>
          );
        },
      },
      {
        title: 'Acciones',
        key: 'actions',
        align: 'center',
        render: (record: any) => {
          return (
            <>
              {!gestorFromWarehouse &&
                record &&
                record.assets &&
                record.assets.length === 0 && (
                  <Tooltip title="Ver adiciones">
                    <CustomButton
                      label="Ver adiciones"
                      onClick={() => {}}
                      size="middle"
                      disabled={true}
                    />
                  </Tooltip>
                )}
              {!gestorFromWarehouse &&
                record &&
                record.assets &&
                record.assets.length > 0 && (
                  <Tooltip title="Ver adiciones">
                    <CustomButton
                      label="Ver adiciones"
                      onClick={() => handleSaveAddition?.(record)}
                      size="middle"
                      disabled={
                        record.assets && record.assets.length > 0 ? false : true
                      }
                    />
                  </Tooltip>
                )}
              {gestorFromWarehouse && (
                <Tooltip title="Gestionar activo">
                  <CustomButton
                    label="Gestionar"
                    onClick={() => {
                      setModalOneAsset(true);
                      setItemSelected(record);
                    }}
                    size="middle"
                    disabled={selectedRowKeys && selectedRowKeys?.length > 0}
                  />
                </Tooltip>
              )}
            </>
          );
        },
      },
    ]);
    setColumnGood([
      {
        title: 'Item',
        dataIndex: 'id',
        key: 'id',
        render: (item: any) => (item ? item : 'Sin registro'),
      },
      {
        title: 'Código de producto',
        dataIndex: 'product_code',
        key: 'product_code',
        render: (item: any) => (item ? item : 'Sin registro'),
      },
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
        render: (item: any) => (item ? item : 'Sin registro'),
      },
      {
        title: 'Grupo de bienes',
        dataIndex: 'good_class',
        key: 'good_class',
        render: (item: any) => (item && item.name ? item.name : 'Sin registro'),
      },
      {
        title: 'Unidad de medida',
        dataIndex: 'unit_measurement',
        key: 'unit_measurement',
        render: (item: any) => (item && item.name ? item.name : 'Sin registro'),
      },
      {
        title: 'Estado por elemento',
        dataIndex: 'status',
        key: 'status',
        render: (status: any) => {
          return status && status.status ? status.status : 'Sin registro';
        },
      },
      {
        title: 'Observaciones',
        dataIndex: 'observations',
        key: 'observations',
        width: 300,
        render: (text: string, record: any) => (
          <Tooltip title={text ? text : 'Sin registro'}>
            <div
              style={{
                maxWidth: 250,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                margin: '0 auto',
              }}
            >
              {text ? text : 'Sin registro'}
            </div>
          </Tooltip>
        ),
      },
      {
        title: 'Acciones',
        key: 'actions',
        align: 'center',
        hidden: !gestorFromWarehouse,
        render: (record: any) => {
          return (
            <>
              {gestorFromWarehouse && (
                <Tooltip title="Gestionar bien">
                  <CustomButton
                    label="Gestionar"
                    onClick={() => {
                      setModalAllAsset(true);
                      handleSelectionChange?.([record.id]);
                    }}
                    size="middle"
                  />
                </Tooltip>
              )}
            </>
          );
        },
      },
    ]);
  }, [selectedRowKeys, filteredData]);

  const handleOnCancelAllAsset = () => {
    setModalAllAsset(false);
    //setIsGestorAny(false);
  };
  return (
    <Fragment>
      <CustomModal
        title=""
        labelSubmit="Aceptar"
        open={modalAllAsset}
        width={1000}
        onCancel={() => handleOnCancelAllAsset()}
        onSave={onSaveManageAllAsset}
        isLoading={true}
        disabledBtn={
          formikItem.values.status_id === '' ||
          formikItem.values.observationsItem === ''
            ? true
            : false
        }
      >
        <ManageAllAsset
          formik={formikItem}
          detailData={detailData}
          goodPetitionItems={refundStates}
        />
      </CustomModal>

      <CustomModal
        title={`Detalle reintegro - ${detailData?.ticket || ''}`}
        labelSubmit="Aceptar"
        open={modalOneAsset}
        width="95vw"
        onCancel={() => handleCancel()}
        onSave={onSaveManageOneAsset}
        disabledBtn={
          formikItem.values.status_id === '' ||
          formikItem.values.observationsItem === ''
            ? true
            : false
        }
      >
        <ManageOneAsset itemSelected={itemSelected} formik={formikItem} />
      </CustomModal>

      <Tabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: (
              <Button type="link" icon={<FileTextOutlined />}>
                Información general
              </Button>
            ),
            children: (
              <>
                <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                  <Col span={24}>
                    <div className="mb-4">
                      <CustomText
                        text="Información general"
                        strong
                        fontSize="big"
                      />
                    </div>
                  </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                  <Col span={6}>
                    <div className="mb-4">
                      <CustomText text="Solicitante:" strong fontSize="small" />
                      <CustomText
                        text={`${detailData?.requester_document} - ${detailData?.requester}`}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-4">
                      <CustomText
                        text="Fecha de solicitud:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={detailData?.query_date || 'Por definir'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-4">
                      <CustomText text="Dependencia:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.dependency || 'Por definir'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-4">
                      <CustomText text="Ubicación:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.location || 'Por definir'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                  <Col span={6}>
                    <div className="mb-4">
                      <CustomText
                        text="Estado de solicitud:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={detailData?.status || 'Por definir'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="mb-4">
                      <CustomText
                        text="Tipo de solicitud:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={
                          detailData?.request_type === 'asset'
                            ? 'Activo fijo'
                            : detailData?.request_type === 'good'
                              ? 'Bien de consumo'
                              : 'Por definir'
                        }
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="mb-4">
                      <CustomText
                        text="Observaciones:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={detailData?.observations || 'Por definir'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  {gestorFromWarehouse && (
                    <Col span={24}>
                      <div className="mb-4">
                        <CustomTextArea
                          label="Observaciones de recepción (Opcional)"
                          name="reason"
                          placeholder="Inserte"
                          value={formikGestor.values.reason}
                          error={formikGestor.errors.reason}
                          touched={formikGestor.touched.reason}
                          onChange={formikGestor.handleChange}
                          onBlur={formikGestor.handleBlur}
                          maxLength={501}
                        />
                      </div>
                    </Col>
                  )}
                </Row>

                <Row gutter={8} align="middle" justify="center">
                  <Col span={12} style={{ textAlign: 'left' }}>
                    <CustomText
                      fontSize="big"
                      text={
                        detailData?.request_type === 'asset'
                          ? 'Listado de activos'
                          : 'Listado de bienes'
                      }
                    />
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <FormInput
                      placeholder="Buscar..."
                      value={searchText}
                      onChange={handleSearch}
                      label={''}
                      name={'search'}
                    />
                  </Col>
                </Row>

                {gestorFromWarehouse && (
                  <Row className="mb-4" gutter={[16, 16]} justify="end">
                    <Col
                      xs={24}
                      sm={24}
                      md={8}
                      lg={8}
                      span={12}
                      style={{ textAlign: 'right' }}
                    >
                      <Button
                        disabled={
                          selectedRowKeys && selectedRowKeys?.length > 0
                            ? false
                            : true
                        }
                        style={
                          selectedRowKeys && selectedRowKeys?.length
                            ? { backgroundColor: '#102486', color: 'white' }
                            : {}
                        }
                        onClick={() => setModalAllAsset(true)}
                      >
                        Gestionar estados
                      </Button>
                    </Col>
                  </Row>
                )}
                {detailData?.request_type === 'asset' && (
                  <>
                    {gestorFromWarehouse && (
                      <Row
                        justify="space-between"
                        align="middle"
                        className="mb-3 ml-1 pb-1"
                      >
                        <Col>
                          <Checkbox
                            indeterminate={
                              !!selectedRowKeys &&
                              !!filteredData &&
                              selectedRowKeys.length > 0 &&
                              selectedRowKeys.length < filteredData.length
                            }
                            checked={
                              !!selectedRowKeys &&
                              !!filteredData &&
                              selectedRowKeys.length === filteredData.length
                            }
                            onChange={(e) => {
                              if (!setSelectedRowKeys || !filteredData) return;

                              if (e.target.checked) {
                                const allKeys = filteredData.map(
                                  (item: any) => item.id
                                );
                                setSelectedRowKeys(allKeys);
                                handleSelectionChange(allKeys);
                              } else {
                                setSelectedRowKeys([]);
                                handleSelectionChange([]);
                              }
                            }}
                          >
                            Seleccionar todos
                          </Checkbox>
                        </Col>
                      </Row>
                    )}
                    <Row gutter={[16, 16]} justify="end">
                      <Col xs={24} sm={24} md={24} lg={24}>
                        {gestorFromWarehouse ? (
                          <CustomSelectableTable
                            loading={isLoadingItems}
                            dataSource={filteredData}
                            columns={columnAsset}
                            rowKey="id"
                            scroll={{ x: 'max-content' }}
                            rowSelection={{
                              selectedRowKeys,
                              onChange: handleSelectionChange,
                            }}
                          />
                        ) : (
                          <CustomTable<Item>
                            loading={isLoadingItems}
                            columns={columnAsset}
                            dataSource={filteredData}
                            rowKey="id"
                            scroll={{ x: 'max-content' }}
                          />
                        )}
                      </Col>
                    </Row>
                  </>
                )}

                {detailData?.request_type === 'good' && (
                  <>
                    <Row gutter={[16, 16]} justify="end">
                      <Col xs={24} sm={24} md={24} lg={24}>
                        {gestorFromWarehouse ? (
                          <CustomSelectableTable
                            dataSource={filteredData}
                            columns={columnGood}
                            rowKey="id"
                            scroll={{ x: 'max-content' }}
                            rowSelection={{
                              selectedRowKeys,
                              onChange: handleSelectionChange,
                            }}
                          />
                        ) : (
                          <CustomTable<Item>
                            columns={columnGood}
                            dataSource={filteredData}
                            rowKey="id"
                            scroll={{ x: 'max-content' }}
                          />
                        )}
                      </Col>
                    </Row>
                  </>
                )}
              </>
            ),
          },
          {
            key: '2',
            label: (
              <Button type="link" icon={<FileSearchOutlined />}>
                Documentos
              </Button>
            ),
            children: (
              <>
                <Table
                  columns={[
                    {
                      title: 'Item',
                      dataIndex: 'index',
                      key: 'index',
                      render: (_, __, index: number) => index + 1,
                    },
                    {
                      title: 'Nombre',
                      dataIndex: 'name',
                      key: 'name',
                    },
                  ]}
                  dataSource={detailData?.documents?.map((doc, index) => ({
                    key: index,
                    createdAt: doc.created_at,
                    name: doc.url?.split('/').pop(),
                    link: doc.url,
                  }))}
                />
                <Divider />
              </>
            ),
          },
          {
            key: '3',
            label: (
              <Button type="link" icon={<HistoryOutlined />}>
                Historial de la solicitud
              </Button>
            ),
            children: (
              <CustomTable
                columns={[
                  {
                    title: 'Item',
                    dataIndex: 'index',
                    key: 'index',
                    render: (_, __, index: number) => index + 1,
                  },
                  {
                    title: 'Fecha',
                    dataIndex: 'date',
                    key: 'date',
                  },
                  {
                    title: 'Realizado por',
                    dataIndex: 'user',
                    key: 'user',
                    render: (_: any, item: any) => {
                      return `${item?.user_document} - ${capitalizeFirstLetter(item?.user)}`;
                    },
                  },
                  {
                    title: 'Observaciones',
                    dataIndex: 'observations',
                    key: 'observations',
                    render: (item: any) =>
                      capitalizeFirstLetter(item) || 'Sin registro',
                  },
                  {
                    title: 'Estado',
                    dataIndex: 'comment',
                    key: 'comment',
                    render: (item: any) => capitalizeFirstLetter(item),
                  },
                ]}
                dataSource={
                  detailData?.history && detailData?.history.length > 0
                    ? detailData?.history.map((item: any, index) => ({
                        key: index,
                        date: item.date,
                        comment: item.comment,
                        observations: item.observations,
                        user: item.user,
                        user_document: item.user_document,
                      }))
                    : []
                }
                pagination={false}
              />
            ),
          },
        ]}
      />
    </Fragment>
  );
};

export default RefundsDetailView;
